import { FormState } from '@vtex/admin-ui-form'
import { FormattedMessage, useIntl } from 'react-intl'
import { RadioInput } from '../../../Radio'
import { ApplyTo } from '../typings'
import { messages } from './messages'

type Props = {
  name: string
  form: FormState
}

const values = [
  {
    value: ApplyTo.cheapest,
    label: <FormattedMessage {...messages.applyTo.cheapest} />,
  },
  {
    value: ApplyTo.mostExpensive,
    label: <FormattedMessage {...messages.applyTo.mostExpensive} />,
  },
]

export function ApplyToField(props: Props) {
  const { name, form } = props

  const { $t } = useIntl()

  return (
    <>
      <RadioInput
        name={name}
        form={form}
        label={$t(messages.applyTo.label)}
        values={values}
        defaultValue={ApplyTo.cheapest}
      />
    </>
  )
}
